import React from 'react';
import Masthead, { MastheadTitle } from '@amzn/meridian/masthead';
import Row from '@amzn/meridian/row';
import Toggle from '@amzn/meridian/toggle';
import Text from '@amzn/meridian/text';
import StoreSelector from 'src/components/selectors/ProgramStoreSelector';
import { CustomDatePicker } from '@components/controls/CustomDatePicker';

interface AgileManagementHeaderProps {
  store: string | null;
  onStoreSelect: (store: string) => void;
  date: string | null;
  onDateChange: (date: string) => void;
  includeDraft: boolean;
  onIncludeDraftChange: (includeDraft: boolean) => void;
}

const AgileManagementHeader: React.FC<AgileManagementHeaderProps> = ({
  store,
  onStoreSelect,
  date,
  onDateChange,
  includeDraft,
  onIncludeDraftChange,
}) => {
  return (
    <Masthead size="large" backgroundColor="surface">
      <MastheadTitle>
        <Row spacing="400" alignmentVertical="bottom">
          <StoreSelector selectedStoreId={store || undefined} onStoreSelect={onStoreSelect} />
          <CustomDatePicker value={date || ''} onChange={onDateChange} label="Date" />
        </Row>
      </MastheadTitle>
      <Toggle size="large" checked={includeDraft} onChange={onIncludeDraftChange}>
        <Text type="b400">Draft Assortment Only</Text>
      </Toggle>
    </Masthead>
  );
};

export default AgileManagementHeader;
